/**
 * Strip leading zeros from numeric input.
 * "010000" → "10000", "00" → "0", "0.5" → "0.5"
 */
export function cleanAmount(raw) {
    if (raw === null || raw === undefined) return "";
    const s = String(raw);
    if (s === "") return "";
    // Allow optional minus, digits, optional single dot, more digits
    const cleaned = s.replace(/[^\d.-]/g, "");
    if (cleaned === "" || cleaned === "-") return cleaned;
    // Split out leading minus
    const neg = cleaned.startsWith("-");
    let body = neg ? cleaned.slice(1) : cleaned;
    // Keep only first dot
    const firstDot = body.indexOf(".");
    if (firstDot !== -1) {
        body = body.slice(0, firstDot + 1) + body.slice(firstDot + 1).replace(/\./g, "");
    }
    // Strip leading zeros unless followed by "." or it's the only char
    if (body.length > 1 && body.startsWith("0") && body[1] !== ".") {
        body = body.replace(/^0+/, "") || "0";
    }
    return (neg ? "-" : "") + body;
}

/**
 * Use with onChange of a numeric input. Returns the cleaned string for state.
 * Example: onChange={(e) => setAmount(handleAmountInput(e.target.value))}
 */
export function handleAmountInput(value) {
    return cleanAmount(value);
}
